import layerContral from '@/utils/contral/layerContral';
export default {
  legends: {
    // 场景名字或者自定义图例
    TGAL: {
      Prot: {
        layers: ['TGAL-prot'],
        txt: 'Prot', // 图例组件显示的文字
        img: '/img/legend/port.png', //图例组件显示的图片
        showLegend: true, // 是否在图例组件中显示
        checked: false
      },
      pier: {
        layers: ['TGAL-pier'],
        txt: 'Pier', // 图例组件显示的文字
        img: '/img/legend/wharf.png', //图例组件显示的图片
        showLegend: true, // 是否在图例组件中显示
        checked: true
      },
      throughputBar: {
        layers: ['TGAL-throughputBar'],
        txt: 'throughputBar', // 图例组件显示的文字
        img: '/img/legend/prot.png', //图例组件显示的图片
        showLegend: false, // 是否在图例组件中显示
        checked: false
      },
      logisticsSource: {
        layers: ['TGAL-logisticsSource'],
        txt: 'Logistics Source', // 图例组件显示的文字
        img: '/img/legend/logistics_source.png', //图例组件显示的图片
        showLegend: true, // 是否在图例组件中显示
        checked: false
      }
    }
  },
  cardName: {
    protDistribution: {
      name: 'protDistribution',
      meta: {
        cname: 'protDistribution'
      },
      legendConfig: 'TGAL',
      legends: ['Prot', 'Pier'],
      sceneName: 'TGAL', // ShenZhenL3 ShenZhenWan
      cameraName: 'default',
      sceneWeather: 'Sunny',
      sceneTime: '11:00'
    },
    rank: {
      name: 'rank',
      meta: {
        cname: 'rank'
      },
      legendConfig: 'TGAL',
      legends: ['Prot', 'throughputBar'],
      sceneName: 'TGAL', // ShenZhenL3 ShenZhenWan
      cameraName: 'rank',
      sceneWeather: 'Sunny',
      sceneTime: '11:00'
    },
    '城市全景-人员热力': {
      name: 'ChengShiQuanJing',
      meta: {
        cname: '城市全景-人员热力'
      },
      legendConfig: 'ShenZhenL0',
      legends: ['人员热力'],
      sceneName: 'ShenZhenL0', // ShenZhenL3 ShenZhenWan
      cameraName: '城市全景'
    },
    '城市全景-重点项目': {
      name: 'ChengShiQuanJing',
      meta: {
        cname: '城市全景-重点项目'
      },
      legendConfig: 'ShenZhenL0',
      legends: ['重点项目'],
      sceneName: 'ShenZhenL0', // ShenZhenL3 ShenZhenWan
      cameraName: '城市全景'
    }
  },
  ...layerContral
};
